/**
 * Account settings (#/account) — mockup-aligned layout using CC glass panels.
 */

import { escapeHtml } from "../../dom.js";

/**
 * @param {{ roleLabel?: string, username?: string, navHtml?: string }} o
 */
function buildAccountSettingsAsideHtml(o) {
  const roleLabel = o.roleLabel || "—";
  const username = o.username || "—";
  const navHtml = o.navHtml || "";
  const navTitle = o.navTitle || "Settings";
  return `
  <aside class="acc-settings-nav glass-panel glass-panel--panel croc-cc-scroll" aria-label="${escapeHtml(navTitle)} menu">
    <header class="acc-settings-nav__head croc-cc-panel-head">
      <h2 class="croc-cc-panel-title">${escapeHtml(navTitle)}</h2>
    </header>
    <nav class="acc-settings-nav__links" aria-label="Account sections">${navHtml}</nav>
    <div class="acc-settings-status glass-panel glass-panel--inset">
      <h3 class="acc-settings-status__title">Account</h3>
      <dl class="acc-settings-status__list">
        <div><dt>Role</dt><dd class="mono">${roleLabel}</dd></div>
        <div><dt>Username</dt><dd class="mono">${username}</dd></div>
      </dl>
    </div>
  </aside>`;
}

/**
 * @param {object} o
 * @returns {string}
 */
export function buildAccountSettingsShellHtml(o) {
  const noSidebar = !!o.noSidebar;
  return `
<section class="acc-settings-page${noSidebar ? " acc-settings-page--no-sidebar" : ""}" aria-label="Account settings">
  ${noSidebar ? "" : buildAccountSettingsAsideHtml({ ...o, navTitle: o.navTitle || "Account" })}
  <div class="acc-settings-grid">
    <div class="acc-settings-col acc-settings-col--main" data-acc-section="profile">
      ${o.profileColHtml || ""}
    </div>
    <div class="acc-settings-col acc-settings-col--mid" data-acc-section="notifications">
      ${o.midColHtml || ""}
    </div>
    <div class="acc-settings-col acc-settings-col--side" data-acc-section="side">
      ${o.sideColHtml || ""}
    </div>
  </div>
</section>`;
}

/**
 * Settings sub-route shell — shared left nav + single content column.
 * @param {{ roleLabel?: string, username?: string, navHtml?: string, contentHtml?: string }} o
 */
export function buildAccountSettingsSubrouteShellHtml(o) {
  return `
<section class="acc-settings-page acc-settings-page--subroute" aria-label="Settings">
  ${buildAccountSettingsAsideHtml({ ...o, navTitle: o.navTitle || "Settings" })}
  <div class="acc-settings-subroute croc-cc-scroll">
    ${o.contentHtml || ""}
  </div>
</section>`;
}

/**
 * @param {Array<{ id: string, label: string, icon?: string, href?: string, section?: string }>} items
 * @param {string} [activeNavId]
 * @param {boolean} [useSectionButtons]
 */
export function buildAccountSettingsNavHtml(items, activeNavId = "profile", useSectionButtons = true) {
  return (items || [])
    .map((it) => {
      const active = it.id === activeNavId ? " acc-settings-nav__link--active" : "";
      const ico = it.icon || "◦";
      const label = escapeHtml(it.label || "");
      if (it.section && useSectionButtons) {
        return `<button type="button" class="acc-settings-nav__link${active}" data-acc-nav="${escapeHtml(it.id)}">
        <span class="acc-settings-nav__ico" aria-hidden="true">${ico}</span>
        <span>${label}</span>
      </button>`;
      }
      const dest = escapeHtml(String(it.href || "account").replace(/^#\/?/, ""));
      return `<button type="button" class="acc-settings-nav__link${active}" data-cc-go="${dest}" data-acc-nav-id="${escapeHtml(it.id)}">
        <span class="acc-settings-nav__ico" aria-hidden="true">${ico}</span>
        <span>${label}</span>
      </button>`;
    })
    .join("");
}
